<template>
  <div class="container">
    <unit-title title="加工环节" />
    <div class="process-list">
      <van-steps direction="vertical" :active="(processLink.processingProcessInfo||[]).length" active-color="#20CAA0">
        <div v-for="(item,key) in processLink.processingProcessInfo" :key="item.id">
          <van-step v-if="item.flag">
            <template v-slot:inactive-icon>
              <div class="inactive">
                {{ key + 1 }}
              </div>
            </template>
            <div class="step-item wh-flex-start">
              <van-image class="img" width="48" height="48" fit="fill" :src="item.photo|firstImgThumb">
                <template v-slot:error>
                  <div class="error-img">
                    暂无<br>图片
                  </div>
                </template>
              </van-image>
              <div class="name">
                <span>{{ item.processName }}</span>
                <span>操作人：{{ item.staffName }}</span>
              </div>
            </div>
          </van-step>
        </div>
      </van-steps>
    </div>
  </div>
</template>
<script>
import { firstImgThumb } from '@/filter'
import UnitTitle from '@/views/productManage/TraceSource/components/UnitTitle'
export default {
  name: 'ProcessLink',
  filters: {
    firstImgThumb
  },
  components: { UnitTitle },
  props: {
    processLink: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>
<style lang="less" scoped>
.inactive{
  background-color: #20CAA0;
  color: #fff;
  margin-top: 60px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
}
/deep/ .van-step--vertical .van-step__line{
  width:2px;
  left: -16px;
  top: 41px;
}
/deep/ .van-step:last-child .van-step__line{
  width: 0;
}
.container {
   .step-item{
        background-color: #F8F8F8;
        height: 80px;
        padding-left: 20px;
        .img{
          margin-top: 5px;
        }
        .name{
        display: flex;
        margin-left: 15px;
        flex-direction: column;
        height: 40px;
        justify-content: space-between;
        span:nth-child(1){
          font-size: 14px;
          font-weight: bold;
          color: #323332;
        }
        span:nth-child(2){
          color: #BBBBBB;
          font-size: 12px;
        }
      }
   }
}
</style>
